/**
 * Technique API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';


class CategoryAllOf {
    
    constructor(id) { 
        
        CategoryAllOf.initialize(this, id);
    }

    
    static initialize(obj, id) { 
        obj['id'] = id;
    }

    
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new CategoryAllOf();

            if (data.hasOwnProperty('id')) {
                obj['id'] = ApiClient.convertToType(data['id'], 'Number');
            }
        }
        return obj;
    }


}


CategoryAllOf.prototype['id'] = undefined;






export default CategoryAllOf;

